import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loadingVisible$ = this.loadingSubject.asObservable();

  private positionSubject = new BehaviorSubject<{ of: string }>({of: '.dx-tabpanel-container',});
  position$ = this.positionSubject.asObservable();


  updatePosition(newSelector: string) {
    this.positionSubject.next({ of: newSelector });
  }

  showLoading(selector?: string) {
    this.loadingSubject.next(true);
    if(selector){
      this.updatePosition(selector);
    }
  }

  hideLoading() {
    this.loadingSubject.next(false);
  }
}
